import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  id: "body",
  class: "basic"
}
const _hoisted_2 = { class: "page-header" }
const _hoisted_3 = { class: "width-wrap" }
const _hoisted_4 = { class: "width-wrap" }
const _hoisted_5 = { class: "page-content section" }
const _hoisted_6 = {
  id: "userProfile-form",
  class: "form",
  autocomplete: "off"
}
const _hoisted_7 = { class: "form-header" }
const _hoisted_8 = { class: "form-body" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = { class: "form-field readonly" }
const _hoisted_11 = { for: "frm-userProfileForm_userName" }
const _hoisted_12 = { class: "form-field readonly" }
const _hoisted_13 = { for: "frm-userProfileForm_email" }
const _hoisted_14 = {
  key: 0,
  class: "form-field readonly"
}
const _hoisted_15 = { for: "frm-userProfileForm_phoneNumber" }
const _hoisted_16 = { class: "form-footer" }
const _hoisted_17 = { class: "buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", null, _toDisplayString(_ctx.$t('UserBasicProfile.title')), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("section", _hoisted_5, [
        _createElementVNode("form", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("h2", null, _toDisplayString(_ctx.$t('UserBasicProfile.form-header')), 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t('UserBasicProfile.username')) + ":", 1),
                _createElementVNode("span", null, _toDisplayString(_ctx.profile.lastName), 1)
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.$t('UserBasicProfile.email')) + ":", 1),
                _createElementVNode("span", null, _toDisplayString(_ctx.profile.email), 1)
              ]),
              (_ctx.profile.phoneNumber)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.$t('UserBasicProfile.phoneNumber')) + ":", 1),
                    _createElementVNode("span", null, _toDisplayString(_ctx.profile.fullPhoneNumber), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_router_link, {
                to: { name: 'UserProfileEdit' },
                tag: "button",
                class: "button button--primary"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('UserBasicProfile.button-edit')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, {
                to: { name: 'ChangePassword' },
                tag: "button",
                class: "button button--primary reversed"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('UserBasicProfile.button-change-password')), 1)
                ]),
                _: 1
              })
            ])
          ])
        ])
      ])
    ])
  ]))
}